import { DISPLAY } from 'constants/display'

export const yesOrNo = (flag, placeholder = null) => {
  if (typeof flag !== 'boolean') return placeholder
  return flag ? DISPLAY.yes : DISPLAY.no
}
